
import Modal from '@/components/modals/Modal.vue'
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'TicketingInfoModal',

	emits: ['close'],

	components: { Modal },

	props: {
		title: {
			type: String,
			required: true
		},

		buttonText: {
			type: String,
			default: 'OK'
		},

		additionalText: {
			type: String,
			default: ''
		},

		icon: {
			type: String,
			default: ''
		},

		loading: {
			type: Boolean,
			default: false
		}
	},

	setup(props, { emit }) {
		// Methods
		const closeModal = () => emit('close')

		return { closeModal }
	}
})
